import React from "react";
import RegularButton from "../../../components/Inputs/Button/RegularButton/RegularButton";
import LabeledInput from "../../../components/Inputs/Labeled/LabeledInput/LabeledInput";
import LabeledTextArea from "../../../components/Inputs/Labeled/LabeledTextArea/LabeledTextArea";
import classes from "./ContactForm.module.css";
import Modal from "../../../components/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { sendMessage, hideContactForm, showContactConfirm } from "../../../store/Contact/actions";

type ContactFormProps = {};

const ContactForm: React.FC<ContactFormProps> = (props) => {
    const contactFormIsShowing = useSelector(
        (state: RootState) => state.contactReducer.contactForm.isShowing
    );

    const dispatch = useDispatch();

    const [isFormValid, setFormValid] = React.useState(true);

    const [sendWasClicked, setSendWasClicked] = React.useState(false);

    const [emailText, setEmailText] = React.useState("");

    const [isEmailValid, setIsEmailValid] = React.useState(true);

    const [messageText, setMessageText] = React.useState("");

    const [isMessageTextValid, setIsMessageTextValid] = React.useState(true);

    const checkEmailValidity = (): boolean => {
        let isValid = true;
        isValid = isValid && emailText.trim().length < 128;
        isValid = isValid && emailText.trim().length > 5;
        const reg = /\S+@\S+\.\S+/;
        isValid = isValid && reg.test(emailText);
        setIsEmailValid(isValid);
        return isValid;
    };

    const checkMessageTextValidity = (): boolean => {
        let isValid = true;
        isValid = isValid && messageText.trim().length > 0;
        setIsMessageTextValid(isValid);
        return isValid;
    };

    const checkFormValidity = (): boolean => {
        let isValid = true;
        isValid = isValid && checkEmailValidity();
        isValid = isValid && checkMessageTextValidity();
        setFormValid(isValid);
        return isValid;
    };

    const checkValidityAfterClick = () => {
        if (sendWasClicked) {
            checkFormValidity();
        }
    };

    React.useEffect(checkValidityAfterClick, [emailText, messageText, sendWasClicked]);

    const sendClickHandler = () => {
        setSendWasClicked(true);
        if (checkFormValidity()) {
            dispatch(sendMessage(emailText, messageText));
            dispatch(hideContactForm());
            dispatch(showContactConfirm());
            setEmailText("");
            setMessageText("");
            setSendWasClicked(false);
        }
    };

    const emailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmailText(event.target.value);
    };

    const messageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessageText(event.target.value);
    };

    return (
        <Modal
            extraClasses={[
                classes.Modal,
                contactFormIsShowing ? classes.doNotOffsetModal : classes.doOffsetModal
            ].join(" ")}>
            <div className={classes.ContactForm}>
                <LabeledInput
                    inputType="text"
                    id="email_"
                    // small="I'll never share your email with anyone else."
                    placeholder="Your E-Mail"
                    label="Email"
                    value={emailText}
                    isValid={isEmailValid}
                    change={emailChangeHandler}></LabeledInput>
                <LabeledTextArea
                    id="message_"
                    // small="I'll reach you soon."
                    placeholder="Your message"
                    label="Message"
                    value={messageText}
                    isValid={isMessageTextValid}
                    change={messageChangeHandler}></LabeledTextArea>
                <RegularButton disabled={!isFormValid} click={sendClickHandler}>
                    Send
                </RegularButton>
            </div>
        </Modal>
    );
};

export default ContactForm;
